angular.module('app').factory('NotificationService',
    ['$rootScope', '$interval', '$log', 'LocalStorageRepository',
        function($rootScope, $interval, $log, LocalStorageRepository) {
            'use strict';

            var notificationPromise;

            function updateNotifications () {
                $log.log('updateNotifications - raising Notification:updated event - ' + moment().format('lll'));

                //$rootScope.$broadcast('Notification:updated', 'Notification event fired : ' + new Date());
                $rootScope.$broadcast('Notification:updated');
            }

            function startNotificationTimer() {
                $log.log('setupNotificationTimer - starting - ' + moment().format('lll'));

                if (!angular.isDefined(notificationPromise)) {
                    $log.log('setupNotificationTimer - initializing notification timer');

                    var timeoutInterval = LocalStorageRepository.getNotificationTimeout();
                    if (typeof timeoutInterval === 'number') {
                        if (timeoutInterval % 1 === 0) {
                            if (timeoutInterval > 0 && timeoutInterval < 100) {
                                timeoutInterval = timeoutInterval * 60000;
                                notificationPromise = $interval(updateNotifications, timeoutInterval, 0, false);
                            }
                        }
                    }

                    if (angular.isDefined(notificationPromise)) {
                        $log.log('setupNotificationTimer - notification timer started successfully.  Timeout Interval is ' + timeoutInterval + ' milliseconds.');
                    }
                    else {
                        $log.log('setupNotificationTimer - not able to start notification timer.  Timeout Interval is >>' + timeoutInterval + '<<');
                    }
                }
                else {
                    $log.log('setupNotificationTimer - notification timer already initialized');
                }

                $log.log('setupNotificationTimer - ending');
            }

            function stopNotificationTimer() {
                $log.log('stopNotificationTimer - starting - ' + moment().format('lll'));

                if (angular.isDefined(notificationPromise)) {
                    $interval.cancel(notificationPromise);
                    notificationPromise = undefined;
                    $log.log('stopNotificationTimer - timer stopped');
                }

                $log.log('stopNotificationTimer - ending');
            }

            $rootScope.$on('$destroy', function() {
                stopNotificationTimer();
            });


            return {
                updateNotifications: updateNotifications,
                startNotificationTimer: startNotificationTimer,
                stopNotificationTimer: stopNotificationTimer
            };
        }
    ]);